export * from './company-information/company-information.component';
export * from './privacy-security-policy/privacy-security-policy.component';
export * from './legal-notice/legal-notice.component';
